import {
  BasketItem,
  BasketRow,
  BasketRowsGroup,
} from 'graphql-api/baskets-api-interfaces';

export interface BasketLinesEntity {
  [itemId: string]: BasketLineItem;
}

export enum BasketLineType {
  ROW,
  GROUP,
}

export interface BasketLineItem {
  id: string;
  parentId: string | null;
  productLines: BasketRow[];
  basketItemIds: string[];
  basketItems: BasketItem[];
  type: BasketLineType;
  data: BasketRowsGroup | BasketRow;
  hasBackOrderBasketItems?: boolean;
}
